import { CustomerSideNextScreenConstants } from "../../../constants/generalConstants";
import useValue from "../../../hooks/useValue";
import { CustomNotification } from "../../../util/CustomNotification";
import * as authService from "../../../services/authService";

import type { AuthUserAPIResponse } from "../../../shared/interface/auth/User.interface";

type UseUpdatePasswordInterface = {
  nextScreenHelper: (response: AuthUserAPIResponse) => void;
  handleNextScreen: (value: CustomerSideNextScreenConstants | null) => void;
};

export const useUpdatePassword = (props: UseUpdatePasswordInterface) => {
  /* CONSTANTS */

  /* STATE */

  /* CUSTOM HOOKS */
  const { value: loader, handleEnableValue: handleEnableLoading, handleDisableValue: handleDisableLoading } = useValue(false);

  /* HANDLERS */
  const handleBack = () => props.handleNextScreen(null);

  const onFinish = async (data: { newPassword: string; confirmPassword: string }) => {
    try {
      handleEnableLoading();
      const response = await authService.updatedPasswordAPI(data.newPassword);

      props.nextScreenHelper(response);
    } catch (error) {
      CustomNotification.showErrorMessage(error);
    } finally {
      handleDisableLoading();
    }
  };

  return { handleBack, loader, onFinish };
};
